DealEventPipe = window.DealEventPipe ?= _(Backbone.Events).clone()

module.exports = DealEventPipe
